import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Nav from "./component/Nav";
import Home from "./Home";
import DynamicPage from "./CaseStudy";
import DynamicPage2 from "./CaseStudy2";
import DynamicPage3 from "./CaseStudy3";
import Gallery1 from "./gallery1";
import Gallery2 from "./gallery2";
import ScrollToTop from "./ScrollToTop";

const Contact = () => <h1>Contact Page</h1>;

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      {/* <Nav /> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/research/LeadrPro" element={<DynamicPage />} />
        <Route path="/research/OffMetaFantasy" element={<DynamicPage2 />} />
        <Route path="/research/InglesMarkets" element={<DynamicPage3 />} />
        <Route path="/screens/orbitly" element={<Gallery1 />} />
        <Route path="/screens/listo" element={<Gallery2 />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<h1>404 - Not Found</h1>} />
      </Routes>
    </Router>
  );
};

export default App;
